import useToggleLocalMute from '@hooks/sdk/useToggleLocalMute';
import { useLocalAudioOutput } from '@providers/LocalAudioOutputProvider';
import { useLocalVideo } from '@providers/LocalVideoProvider';
import { useMemo, type FC } from 'react';
import { Container, IconWrapper } from './style';
import AllOffIcon from '/icon/offAll.svg';
import AllOnIcon from '/icon/onAll.svg';

const AllToggle: FC = () => {
  const { isAudioOn, toggleAudio } = useLocalAudioOutput();
  const { isVideoEnabled, toggleVideo } = useLocalVideo();
  const { muted, toggleMute } = useToggleLocalMute();

  const isOn = useMemo(
    () => isAudioOn && !muted && isVideoEnabled,
    [isAudioOn, isVideoEnabled, muted],
  );
  const isOff = useMemo(
    () => !isAudioOn && muted && !isVideoEnabled,
    [isAudioOn, isVideoEnabled, muted],
  );

  const toggleAll = () => {
    toggleAudio();
    toggleMute();
    toggleVideo();
  };

  // 하나라도 꺼져있을 경우 전부 켜짐
  const onClickSync = () => {
    if (isOn || isOff) return toggleAll();

    if (!isAudioOn) toggleAudio();
    if (muted) toggleMute();
    if (!isVideoEnabled) toggleVideo();
  };

  return (
    <Container onClick={onClickSync} isActive={isOn}>
      <IconWrapper>
        <img src={isOn ? AllOnIcon : AllOffIcon} />
      </IconWrapper>
      <span>{`${isOn ? '전부 켜짐' : '전부 꺼짐'}`}</span>
    </Container>
  );
};

export default AllToggle;
